module.exports = __webpack_public_path__ + "img/header.ae32850b.png";